/* eslint-disable*/
import {
  Link as RouterLink,
  useNavigate,
  useSearchParams
} from 'react-router-dom';
import { useEffect, useState, memo, useRef } from 'react';
import { Box, Typography, Link } from '@material-ui/core'; // eslint-disable-line

const TrialCampaignRegisterComplete = memo(() => {
  const [searchParams] = useSearchParams();

  const start = searchParams.get('start');

  return (
    <>
      <Box xs={12} textAlign="center" backgroundColor="#F7FCFF" pt={5}>
        <Typography variant="h5" fontSize={'14px'}>
          お申し込みありがとうございました。
        </Typography>
        <Typography variant="h5" mb={3} fontSize={'14px'}>
          まだ入金の手続きが完了しておりません。
        </Typography>
        <Typography variant="h4" mb={3}>
          次に
          {start == 7 ? (
            <Link
              href="https://buy.stripe.com/8wM6qIeEN17c5na28o"
              underline="hover"
              fontSize="25px"
            >
              カード決済手続き
            </Link>
          ) : start == 8 ? (
            <Link
              href="https://buy.stripe.com/7sIaGYcwF6rwg1O00f"
              fontSize="25px"
              underline="hover"
            >
              カード決済手続き
            </Link>
          ) : (
            'カード決済手続き'
          )}
          をお願いします。
        </Typography>

        <Typography variant="h5" fontSize={'14px'}>
          請求書払いをご希望の方は
          <a
            href="mailto:introduction_oxcim@mg.opt.ne.jp"
            target="_blank"
            rel="noopener"
          >
            introduction_oxcim@mg.opt.ne.jp
          </a>
          に連絡ください
        </Typography>
        <Typography variant="h5" fontSize={'14px'} pb={3}>
          カード決済手続き完了次第、カスタマーサポ―トから利用開始のご案内をいたします。
        </Typography>
      </Box>
    </>
  );
});

export default TrialCampaignRegisterComplete;
